import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Icon, Modal, Button } from "antd";
import NavBar from "../nav/NavBar/NavBar";
import Sidebar from "../../app/common/util/Sidebar";
import {
  getUserPermissions,
  successToast,
  errorToast,
} from "../../app/common/util/genericUtils";
import WhatsappIcon from "../whatsapp/WhatsappIcon";
import { NOTIFICATION_TRIGGERS } from "./triggersConfig";
import { triggerWhatsappNotificationApiCall } from "./api";
import { parseTriggerResponse } from "./responseHandler";

const CAN_BROADCAST = "can_broadcast_notifications";

class NotificationTriggersPage extends Component {
  state = {
    triggeringId: null,
  };

  canBroadcast = () => {
    const permissions = getUserPermissions() || [];
    return permissions.includes(CAN_BROADCAST);
  };

  runTrigger = async (trigger) => {
    this.setState({ triggeringId: trigger.id });
    try {
      const payload = trigger.buildPayload ? trigger.buildPayload() : {};
      const response = await this.callTriggerApi(trigger.id, payload);
      const result = parseTriggerResponse(
        (response && response.data) || {}
      );

      if (result.success) {
        successToast("Success", result.uiMessage);
      } else {
        errorToast(
          "Validation Error",
          result.fieldErrors.length
            ? result.fieldErrors.join("\n")
            : result.uiMessage
        );
      }
    } catch (error) {
      errorToast(
        "Error",
        (error.response &&
          error.response.data &&
          (error.response.data.ui_message ||
            error.response.data.developer_message)) ||
          error.message ||
          "Failed to trigger notification."
      );
    } finally {
      this.setState({ triggeringId: null });
    }
  };

  callTriggerApi = (triggerId, payload) => {
    switch (triggerId) {
      case "whatsapp-dispatch":
        return triggerWhatsappNotificationApiCall(payload);
      default:
        return Promise.reject(
          new Error(`No API mapped for trigger: ${triggerId}`)
        );
    }
  };

  handleActionClick = (trigger) => {
    Modal.confirm({
      title: trigger.confirmTitle || "Confirm",
      content: trigger.confirmContent || "Are you sure you want to continue?",
      okText: trigger.actionLabel || "Confirm",
      okType: "primary",
      cancelText: "Cancel",
      onOk: () => this.runTrigger(trigger),
    });
  };

  renderTriggerIcon = (trigger) => {
    if (trigger.icon === "whatsapp") {
      return <WhatsappIcon size={22} />;
    }
    return <Icon type={trigger.icon} />;
  };

  renderTriggerCard = (trigger) => {
    const { triggeringId } = this.state;
    const isLoading = triggeringId === trigger.id;

    return (
      <article
        key={trigger.id}
        className="notify-trigger-card"
        style={{ "--trigger-accent": trigger.accent }}
      >
        <div className="notify-trigger-card__icon-wrap">
          {this.renderTriggerIcon(trigger)}
        </div>
        <div className="notify-trigger-card__body">
          <h2 className="notify-trigger-card__title">{trigger.title}</h2>
          <p className="notify-trigger-card__desc">{trigger.description}</p>
        </div>
        <Button
          type="primary"
          className="notify-trigger-card__action"
          loading={isLoading}
          disabled={Boolean(triggeringId)}
          onClick={() => this.handleActionClick(trigger)}
        >
          {trigger.actionLabel}
        </Button>
      </article>
    );
  };

  render() {
    if (!this.canBroadcast()) {
      return <Redirect to="/" />;
    }

    const triggers = NOTIFICATION_TRIGGERS.filter((t) => t.available);

    return (
      <div className="notify-triggers-shell">
        <Sidebar />
        <NavBar />
        <main className="notify-triggers-page">
          <header className="notify-triggers-page__hero">
            <div className="notify-triggers-page__hero-text">
              <p className="notify-triggers-page__eyebrow">Operations</p>
              <h1 className="notify-triggers-page__title">
                Notification Triggers
              </h1>
              <p className="notify-triggers-page__subtitle">
                Fire outbound customer notifications. Each action registers a
                background job — results are not waited on here.
              </p>
            </div>
          </header>

          <section className="notify-triggers-grid">
            {triggers.map(this.renderTriggerCard)}
          </section>
        </main>
      </div>
    );
  }
}

export default NotificationTriggersPage;
